import type { ReactNode } from 'react';

interface CardProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
}

export function Card({ title, subtitle, children, className = '' }: CardProps) {
  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-100 ${className}`}>
      {(title || subtitle) && (
        <div className="px-6 py-5 border-b border-gray-100">
          {title && <h2 className="text-lg font-semibold text-gray-800">{title}</h2>}
          {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
        </div>
      )}
      <div className="p-6">{children}</div>
    </div>
  );
}

/** Kotak dengan accent bar hijau di kiri — branding Booku. */
export function AccentCard({ title, subtitle, children, className = '' }: CardProps) {
  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-100 ${className}`}>
      <div className="px-6 py-5 flex items-start gap-4 border-b border-gray-100">
        <div className="w-1 h-10 bg-booku-primary rounded flex-shrink-0 mt-0.5" />
        <div>
          {title && <h1 className="text-xl font-semibold text-gray-800">{title}</h1>}
          {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      <div className="p-6">{children}</div>
    </div>
  );
}
